export class Proceduresresources{
    constructor(
        public id: number,
       public procID: number,
       public resourceName: string,
       public resourceId: number,
       public interval: number,
       public procName:string,
       public roleName: string,
       public internalId:number,
       public locationProcdeureId:number,
       public locationId:number

    ){}

}
